const socialListeningRoute = [
  {
    path: "/:appId/social-listening",
    name: "social-listening.listening-insights.overview-listening",
    component: () =>
      import("@/views/social-listening/pages/SocialListeningMain.vue"),
    meta: { title: "Social Listening" },
  },
  {
    path: "/:appId/social-listening",
    name: "social-listening.social-analytics",
    component: () =>
      import("@/views/social-listening/pages/SocialListeningMain.vue"),
    meta: { title: "Social Listening" },
  },
  {
    path: "/:appId/social-listening",
    name: "social-listening.listening-insights",
    component: () =>
      import("@/views/social-listening/pages/SocialListeningMain.vue"),
    meta: { title: "Social Listening" },
  },

  {
    path: "/:appId/social-listening/google-review",
    name: "social-listening.customer-review.google-review",
    component: () => import("@/views/social-listening/pages/GoogleReview.vue"),
    meta: { title: "Social Listening - Google Review" },
  },
  {
    path: "/:appId/social-listening/google-review",
    name: "social-listening.customer-review",
    component: () => import("@/views/social-listening/pages/GoogleReview.vue"),
    meta: { title: "Social Listening - Google Review" },
  },
];

export default socialListeningRoute;
